// MENU
export const MENU_SUCCESS = 'MENU_SUCCESS';
export const EDIT_MENU = 'EDIT_MENU';
export const EDIT_THEME = 'EDIT_THEME';
// SECTIONS
export const SECTION_SUCCESS = 'SECTION_SUCCESS';
export const CREATE_SECTION = 'CREATE_SECTION';
export const EDIT_SECTION = 'EDIT_SECTION';
export const DELETE_SECTION = 'DELETE_SECTION';
// PRODUCTS
export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const EDIT_PRODUCT = 'EDIT_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
// SECTIONS AND PRODUCTS
export const MOVE_ITEM = 'MOVE_ITEM';
export const REORDER_ITEMS = 'REORDER_ITEMS';
export const REORDER_SECTION_CONTENTS = 'REORDER_SECTION_CONTENTS';
// BREADCRUMBS
export const BREADCRUMB_SUCCESS = 'BREADCRUMB_SUCCESS';
// RESET DATA
export const RESET_MENU_EDITOR = 'RESET_MENU_EDITOR';
